// StylesMixin

import { Component, Mixins } from 'vue-property-decorator';
import { VuetifyMixin } from './VuetifyMixin';
import { StringsMixin } from './StringsMixin';

@Component
export class StylesMixin extends Mixins(VuetifyMixin, StringsMixin) {

    get styleWrap(): Record<string, any> {
        return {
            whiteSpace: 'pre-wrap',
            overflowWrap: 'normal',
            wordBreak: 'normal'
        };
    }

    styleContained(height: string = ''): Record<string, any> {
        return {
            'overflow-y': 'auto',
            'maxHeight': this.Height(height),
        }
    }

    Height(height): string {
        if( this.IsNotEmpty(height) ) return height;

        if( this.IsMobile ) return '325px';
        if( this.IsLargeScreen) return '375px';
        return '350px';
    }
}